module.exports = __webpack_public_path__ + "aaf7b489250da262fcc3c44e14f8e10a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/document-unread.svg
// module id = 96
// module chunks = 0